import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable, ReplaySubject } from "rxjs";

export interface IVersion {
    id?: number | null | undefined;
    periodName?: string | null | undefined; // remove?
    scenario_naam?: string | null | undefined;
    scenario_omschrijving?: string | null | undefined;
    date_created?: string | null | undefined;
    is_primary?: boolean | null | undefined;
    is_test?: boolean | null | undefined;
    locked?: boolean | null | undefined;
    is_readonly?: boolean | null | undefined;
    data_version_naam?: string | null | undefined;
    display_version_id?: number | undefined;
    ziekenhuiscode?: number | undefined;
}

/**
 * @deprecated To be merged with ScenarioService, so use it instead
 */
@Injectable({ providedIn: "root" })
export class VersionService<TVersion extends IVersion> {
    protected http = inject(HttpClient);

    protected _version = new ReplaySubject<TVersion>();
    readonly version = this._version.asObservable();

    initialize(): void {
        this.reload();
    }

    reload(): void {
        this.http.get<TVersion>("api/version/current").subscribe(version => {
            this._version.next(version);
        });
    }

    set(version: TVersion): void {
        this._version.next(version);
    }

    get(): Observable<TVersion> {
        return this.version;
    }
}
